<template>
    <div id="window-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Оконные проёмы</div>
        <div class="sidebar-text-area">Обведите контуром плоскость <span class="red-text bold-text">оконного проёма</span>, поочерёдно расставляя точки, соответствующие углам плоскости на изображении в рабочей области. Плоскость будет считаться завершенной, если замкнуть контур.</div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/window_outline.svg')"/>
        </div>
        <div class="sidebar-text-area">Если вам нужно настроить выделяемую зону так, чтобы она более точно соответствовала существующей поверхности, увеличьте количество точек по периметру и, перетаскивая их, редактируйте поверхность.</div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";

    export default {
        name: "WindowSidebarMenu",
        mixins: [urlForStaticVue]
    }
</script>

<style scoped>

</style>
